var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 78,
    viewBox: "0 0 241 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3617_14887)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3617_14887",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 241,
    height: 78
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240.323 0.202148H0.323242V77.7109H240.323V0.202148Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3617_14887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.4457 1.57068L60.0245 76.5382H39.5245L24.0632 16.7107C23.1245 13.0257 22.3082 11.6757 19.4532 10.1232C14.7932 7.59443 7.09574 5.22318 0.323242 3.75068L0.783242 1.57068H33.782C37.9882 1.57068 41.7695 4.37068 42.7245 9.21443L50.8907 52.5944L71.0732 1.57068H91.4457ZM171.769 52.0619C171.852 32.2757 144.409 31.1857 144.598 22.3469C144.657 19.6569 147.218 16.7969 152.824 16.0669C155.603 15.7032 163.259 15.4257 171.943 19.4219L175.349 3.52443C170.683 1.83068 164.679 0.200684 157.209 0.200684C138.041 0.200684 124.551 10.3907 124.437 24.9819C124.313 35.7744 134.066 41.7969 141.413 45.3832C148.972 49.0557 151.508 51.4157 151.479 54.7007C151.426 59.7294 145.451 61.9494 139.867 62.0369C130.119 62.1869 124.463 59.3994 119.954 57.3032L116.439 73.7269C120.971 75.8057 129.334 77.6194 138.006 77.7107C158.379 77.7107 171.707 67.6469 171.769 52.0619ZM222.387 76.5394H240.323L224.667 1.57068H208.112C204.389 1.57068 201.249 3.73818 199.859 7.07068L170.758 76.5382H191.122L195.166 65.3394H220.047L222.388 76.5382L222.387 76.5394ZM200.748 49.9757L210.956 21.8282L216.831 49.9757H200.748ZM119.156 1.57068L103.119 76.5382H83.727L99.7695 1.57068H119.156Z",
    fill: "#1434CB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3617_14887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 241,
    height: 78,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.ac3c2930b648371ea5add2de9bbd5e7f.svg";
export { ForwardRef as ReactComponent };